import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null,
    token: null,
    tabs: {
      active: '',
      items: []
    }
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    TABS_ADD(state, tab) {
      if (!tab || !tab.key || !tab.path) return
      const idx = state.tabs.items.findIndex(t => t.key === tab.key)
      const next = {
        key: tab.key,
        path: tab.path,
        title: tab.title || tab.path,
        closable: tab.closable !== false
      }
      if (idx >= 0) {
        state.tabs.items.splice(idx, 1, { ...state.tabs.items[idx], ...next })
      } else {
        state.tabs.items.push(next)
      }
      state.tabs.active = tab.key
    },
    TABS_SET_ACTIVE(state, key) {
      state.tabs.active = key
    },
    TABS_REMOVE(state, key) {
      const idx = state.tabs.items.findIndex(t => t.key === key)
      if (idx < 0) return
      state.tabs.items.splice(idx, 1)
      if (state.tabs.active === key) {
        const fallback = state.tabs.items[idx] || state.tabs.items[idx - 1] || state.tabs.items[0]
        state.tabs.active = fallback ? fallback.key : ''
      }
    },
    TABS_CLOSE_OTHERS(state, key) {
      state.tabs.items = state.tabs.items.filter(t => t.key === key || t.closable === false)
      state.tabs.active = key
    },
    TABS_CLOSE_ALL(state) {
      state.tabs.items = state.tabs.items.filter(t => t.closable === false)
      state.tabs.active = state.tabs.items[0]?.key || ''
    }
  },
  actions: {
    setUser({ commit }, user) {
      commit('SET_USER', user)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    addTab({ commit }, tab) {
      commit('TABS_ADD', tab)
    },
    setActiveTab({ commit }, key) {
      commit('TABS_SET_ACTIVE', key)
    },
    removeTab({ commit }, key) {
      commit('TABS_REMOVE', key)
    },
    closeOthers({ commit }, key) {
      commit('TABS_CLOSE_OTHERS', key)
    },
    closeAll({ commit }) {
      commit('TABS_CLOSE_ALL')
    }
  },
  modules: {}
})

